import * as Cookies from 'js-cookie';
import {ConstantsService} from "../services/constants/constants.service";
import {environment} from "../../environments/environment";


// Helper function to get correct JWT
export const jwtGetter = () => {
  if (environment.use_global_id) {
    return Cookies.get(ConstantsService.AUTH_TOKEN);
  } else {
    return Cookies.get(ConstantsService.DEPRECATED_AUTH_TOKEN);
  }
};
